Vue.component('date-picker', {
    props: {
        emit_callback: {
            type: String,
            default: 'update-generic-date'
        },
        startDate: Object
    },
    template: `
        <div ref="reviews_date_picker" class="dropdown-select date-picker">{{ dateText }}</div>
    `,

    computed: {

        dateText() {

            let copy = {}

            try {
                copy = Object.assign( Object.create( Object.getPrototypeOf(this.date)), this.date)
            } catch (error) {
                return this.dateLabel                
            }

            return copy.format("D MMM YYYY")
        }

    },

    data() {
        return {
            date: null,
            dateLabel: 'Pick a date',
        }
    },

    mounted() {
    
        moment.locale()
        
        const element = this.$refs.reviews_date_picker
        const date = this.startDate ? this.startDate : moment();
        
        $(element).daterangepicker({
            singleDatePicker: true,
            opens: 'center',
            showDropdowns: false,
            startDate: date,
            autoUpdateInput: false,
            autoApply: false,
            minYear: (new Date()).getFullYear(),
            locale: {
                cancelLabel: 'Clear'
            }
        }, this.updateDate)

    },

    methods: {
        setDate(date) {
            const element = this.$refs.reviews_date_picker
            $(element).data().daterangepicker.startDate = date
        },
        updateDate(date) {
            this.date = date
            let copy = Object.assign( Object.create( Object.getPrototypeOf(this.date)), this.date)
            const dateStr = copy.format("YYYY-MM-DD");
            this.$eventHub.$emit(this.emit_callback, dateStr);
            this.$emit('date-picker-updated', dateStr);
        }
    }
});